<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h-toolbarBg">
        <ejs-toolbar :items="toolbarItems"></ejs-toolbar>
        <div class='h-inputBox'>
          {{$t('Monitor.task.product')}}:
          <ejs-dropdownlist :dataSource="productList" v-model="product"
              :fields="fieldsType" name="productCheck"  @change="productChange" ></ejs-dropdownlist>
        </div>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <div class='h-inputBox'>
          {{$t('Monitor.systemLog.logType')}}:
          <ejs-dropdownlist :dataSource="logTypeList" v-model="logType"
              :fields="fieldsType" name="logTypeCheck"  @change="logTypeChange" ></ejs-dropdownlist>
        </div>
      </div>
      <div class="h100-80 h-scroll">
        <ejs-grid :dataSource="monitorSystemLogData" :allowPaging="true" ref="grid" :pageSettings="pageSettings" :height="screenHeight" :allowExcelExport='true' >
          <e-columns>
            <!-- <e-column type="checkbox" width="50" textAlign="center"></e-column> -->
            <e-column field="id" :visible="false"></e-column>
            <e-column field="product" :headerText="$t('Monitor.systemLog.product')" width="120" textAlign="Center"></e-column>
            <e-column field="systemInfo" :headerText="$t('Monitor.systemLog.systemInfo')" width="120" textAlign="Center"></e-column>
            <!-- <e-column field="processInfo" :headerText="$t('Monitor.systemLog.processInfo')" width="120" textAlign="Center"></e-column> -->
            <e-column field="logType" :headerText="$t('Monitor.systemLog.logType')" :formatter='logTypeFormat' width="120" textAlign="Center"></e-column>
            <e-column field="recordTime" :headerText="$t('Monitor.systemLog.recordTime')" :format="dateFormat" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
            <e-column field="productStart" :headerText="$t('Monitor.systemLog.productStart')" :format="dateFormat" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
            <e-column field="productEnd" :headerText="$t('Monitor.systemLog.productEnd')" :format="dateFormat" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
            <e-column field="message" :headerText="$t('Monitor.systemLog.message')" width="120" textAlign="Center"></e-column>
          </e-columns>
        </ejs-grid>
        <ejs-pager
          ref="pager"
          :pageSize="pageSettings.pageSize"
          :pageCount="page.pageCount"
          :currentPage="page.pageNo"
          :totalRecordsCount="page.totalRecordsCount"
          @click="getMonitorTaskList"
        ></ejs-pager>
      </div>
      <CustomDialog ref="productOperationDialog" v-bind:element="operatDialog.element" v-bind:styles="operatDialog.styles" >
        <template v-slot:dialog-content>
          <ProductOperation ref="productOperationPage"></ProductOperation>
        </template>
      </CustomDialog>
      </template>
  </BasicLayout>
</template>
<script>
import CustomDialog from "../../components/common/CustomDialog";
import BasicLayout from '../../layouts/BasicLayout';
import {ExcelExport} from '@syncfusion/ej2-vue-grids';
import ProductOperation from './monitorTask/productOperation';

export default {
  name: 'monitorSystemLog',
  provide: {
    grid: [ExcelExport]
  },
  components: {
    CustomDialog,
    BasicLayout,
    ProductOperation,
  },
  data() {
    return {
      monitorSystemLogData: [],
      left: { show: false, name: '' },
      middle: { show: false, name: '' },
      right: { show: true, crumb: `${this.$t('Security.securityManage')}`+'/' + `${this.$t('Monitor.monitor')}` + '/' + `${this.$t('Monitor.systemLog.titleName')}` },
      toolbarItems: [
        { prefixIcon: 'icon hero-icon hero-icon-business-operation', tooltipText: this.$t('Monitor.systemLog.operation'), click: this.operationShow },
        { prefixIcon: 'icon hero-icon hero-icon-refresh', tooltipText: this.$t('Alarm.refresh'), click: this.refreshGrid },
      ],
      product: '',
      logType: '',
      productList: [],
      logTypeList: [
        { text: `${this.$t('MCS.all')}`, value: "" },
        { text: `${this.$t('Monitor.systemLog.run')}`, value: "run" },
        { text: `${this.$t('Monitor.systemLog.start')}`, value: "start" },
      ],
      pageSettings: { pageSize: 15 },
      page: {
        pageCount: 4,
        totalRecordsCount: 0,
        pageNo: 1,
      },
      dateFormat: {
        type: 'date', format: 'yyyy-MM-dd HH:mm:ss'
      },
      fieldsType: {
          text: "text",
          value: "value"
      },
      addStatus: true,
      operatDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'productOperationDialog',
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('Common.close')}` }
            },
          ],
          title: `${this.$t('Monitor.systemLog.operation')}`
        },
        styles: {
          width: '500px',
          height: '500px',
          model: true,
          visible: false
        }
      },
      screenHeight: document.body.clientHeight - 240
    };
  },
  mounted() {
    this.getMonitorTaskList();
    this.getProductList();
    let That = this;
  },
  methods: {
    logTypeFormat(grids, data) {
      if(data.logType == 'run'){
        return `${this.$t('Monitor.systemLog.run')}`;
      }else if(data.logType == 'start'){
        return `${this.$t('Monitor.systemLog.start')}`;
      }
    },
    getMonitorTaskList() {
      const url = '/lte/ems/sys/monitor/log/queryMonitorSysLog';
      this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = { params: {
        product: this.product,
        logType: this.logType,
        pageNo: this.page.pageNo,
        pageSize: this.pageSettings.pageSize
      } };
      const That = this;
      this.axios.get(url, params).then(response => {
        const result = response.data.result;
        result.forEach((v) => {
          if (!!v.recordTime) {
            let date = new Date();
            date.setTime(v.recordTime);
            v.recordTime = date;
          }
          if (!!v.productStart) {
            let date = new Date();
            date.setTime(v.productStart);
            v.productStart = date;
          }
          if (!!v.productEnd) {
            let date = new Date();
            date.setTime(v.productEnd);
            v.productEnd = date;
          }
          if (v.logType =='start' && v.status == '0') {
            v.productEnd = null;
          }
        });
        That.monitorSystemLogData = result;
        That.page.totalRecordsCount = response.data.totalCount;
      });
    },
    productChange(msg){
      this.product = msg.value;
      this.getMonitorTaskList();
    },
    operationShow() {
      this.$refs.productOperationPage.getproductList();
      this.$refs.productOperationDialog.show();
    },
    logTypeChange(msg){
      this.logType = msg.value;
      this.getMonitorTaskList();
    },
    getProductList() {
      this.$axios.get("/lte/ems/sys/monitor/log/findProducts").then(response => {
          let resultVal = response.data.resultVal;
          resultVal = resultVal.filter(item => !item.includes('ems_5gc') && !item.includes('ems_gnb') && !item.includes('ems_tr069'));
          this.productList.push({ text: `${this.$t('MCS.all')}`, value: "" });
          for (let i = 0; i < resultVal.length; i++) {
              this.productList.push({
                  text: resultVal[i],
                  value: resultVal[i],
              });
          }
      });
    },

    dialogHide() {
      this.$refs.productOperationDialog.clear();
      this.$refs.productOperationDialog.close();
    },
    filterMonitorTask() {
      this.getMonitorTaskList();
    },
    refreshGrid() {
      this.product='';
      this.logType='';
      this.getMonitorTaskList();
    },
  },
  watch: {
    screenHeight(val) {
      this.screenHeight = val;
    }
  }
};
</script>
